import { RNVJNavigationTriggerV2 } from '@indeed/signals-schema/com/indeed/signals/schema/viewjob/RNVJNavigationTriggerV2';

export type RNVJNavigationTrigger = 'deeplink' | 'unknown';

export function toSignalsRNVJNavigationTrigger(
    trigger: RNVJNavigationTrigger | null | undefined,
): RNVJNavigationTriggerV2 {
    switch (trigger) {
        case 'deeplink':
            return RNVJNavigationTriggerV2.deeplink;
        case 'unknown':
        default:
            return RNVJNavigationTriggerV2.unknown;
    }
}
